import { ITranslations } from 'types/common';
import { RequestsTransFields } from './types';
import en from 'translations/en/requests.json';
import pl from 'translations/pl/requests.json';
import sl from 'translations/sl/requests.json';

export const requestsTranslations: ITranslations<RequestsTransFields> = {
  name: 'requests',
  en,
  pl,
  sl,
};
